{
    "TITLE": "Portal de Métodos de Verificación X",
    "WELCOME": "Welcome",
    "PASSWORD": "Password",
    "LOGIN": "Login",
    "LANGUAGE": "Language",
    "DASHBOARD": "Requests Board",
    "USER": "User",
    "LOGOUT": "Logout",
    "MENU": "Menu",
    "FILTER": "Filter",
    "SIESPNUMBER": "SIESPX #",
    "TYPE": "Type",
    "NAME": "Name",
    "FIRSTLASTNAME": "First Last Name",
    "SECONDLASTNAME": "Second Last Name",
    "STATUS": "Status",
    "STARTOFRESEARCH": "Start of Research",
    "RESULT": "Result",
    "NEWREQUEST": "New Request",
    "CREATEREQUEST": "Create Request",
    "BACK": "Back",
    "MAINPERSON": "Personal Information",
    "REFERENCES": "References",
    "OTHERRELATIVES": "Other Relatives",
    "JOBS": "Jobs",
    "GENERALINFORMATION": "General Information",
    "DIVISION": "Division",
    "REQUIREDFIELD": "Required Field",
    "LASTNAME": "Last Name",
    "ADDRESS": "Address",
    "COUNTRY": "Country",
    "STATE": "State",
    "CITY": "City",
    "STREET": "Street",
    "POSTALCODE": "Postal Code",
    "BIRTHDATA": "Birth Data",
    "BIRTHCOUNTRY": "Birth Country",
    "BIRTHSTATE": "Birth State",
    "BIRTHCITY": "Birth City",
    "BIRTHDATE": "Birth Date",
    "RELATIVES": "Relatives",
    "FATHER": "Father",
    "OCCUPATION": "Occupation",
    "MOTHER": "Mother",
    "UNKNOWN": "Unknown",
    "CANDIDATETYPE": "Candidate Type",
    "SELECTCANDIDATETYPE": "Select the type of candidate",
    "CANCEL": "Cancel",
    "CONTINUE": "Continue",
    "ADDRELATIVE": "Add Relative",
    "SEARCHINTABLE": "Search in table",
    "ACTIONS": "Actions",
    "ADDJOB": "Add Job",
    "COMPANY": "Company",
    "POSITION": "Position",
    "STARTDATE": "Start Date",
    "ENDDATE": "End Date",
    "ISACTIVE": "Is Active?",
    "AGE": "Age",
    "ADDREFERENCE": "Add Reference",
    "MARITALSTATUS": "Marital Status",
    "NATIONALIDENTITYTYPE": "National Identity Type",
    "NATIONALID": "National Id",
    "NUMBER": "Number",
    "COLOGNE": "Cologne",
    "NOTES": "Notes",
    "SAVE": "Save",
    "SELECTOPTION": "Select an option",
    "GENDER": "Gender",
    "TAXNUMBERTYPE": "Tax Number Type",
    "TAXID": "Tax Number",
    "ENTERTAXID": "Enter tax number",
    "SOCIALTYPEID": "Social Security Type",
    "SOCIALID": "Social Security Number",
    "ENTERSOCIALID": "Enter social security number",
    "ENTERNAME": "Enter Name",
    "ENTERFIRSTLASTNAME": "Enter first last name",
    "ENTERSECONDLASTNAME": "Enter second last name",
    "ENTERBIRTHDATE": "Enter birthdate",
    "ENTERCOMMENT": "Enter a comment",
    "COMMENTS": "Comments",
    "ENTERNATIONALID": "Enter national id number",
    "ENTERSTREET": "Enter street",
    "ENTERINTNUMBER": "Enter internal number",
    "ENTEREXTNUMBER": "Enter external number",
    "ENTERSUBLOCALITY": "Enter sublocality",
    "ENTERPOSTALCODE": "Enter postal code",
    "INTNUMBER": "Internal Number",
    "EXTNUMBER": "External Number",
    "SPOUSE": "Spouse",
    "RELATIVE": "Relative",
    "SCHOOLING": "Schooling",
    "PROFESSION": "Profession",
    "ENTERPROFESSION": "Enter the profession",
    "RELATIVETYPE": "Relative Type",
    "ADD": "Add",
    "EDIT": "Edit",
    "CONFIRMATION": "Confirmation",
    "SECURITY": "Security",
    "PLEASEENTERSECURITYCODE": "Please, enter the authenticator code sent to your device.",
    "MFACODE": "MFA Code",
    "VALIDATE": "Validate",
    "EDITRELATIVE": "Edit Relative",
    "EDITJOB": "Edit Job",
    "ENTERCOMPANYNAME": "Enter company name",
    "ENTERPOSITIONNAME": "Enter position name",
    "ENTERSTARTDATE": "Enter the start date",
    "ENTERENDDATE": "Enter the end date",
    "ENTERAGE": "Enter age",
    "EDITREFERENCE": "Edit Reference",
    "DELETE": "Delete",
    "PROGRESS": "Progress",
    "LOADING": "Loading",
    "SENDTOSIES": "Send to SIES",
    "COMPLETEDPROGRESS": "Completion progress",
    "SENT": "In research",
    "EXPIRATIONDATE": "Expiration Date",
    "SEEREQUEST": "See request",
    "SEND": "Send",
    "COMPLETED": "Completed",
    "SEERESULT": "See result",
    "SEMAPHORE": "Semaphore",
    "REQUEST": "Request",
    "CLOSE": "Close",
    "REPORTS": "Reports",
    "DOWNLOADREPORT": "Download Report",
    "SELECTDATESRANGE": "Select Dates Range",
    "NODATAMATCHING": "No data matching the filter",
    "DOWNLOADPROCESSEDREQUESTREPORT": "Download processed requests report",
    "EVIDENCES": "Evidences",
    "RESUBMIT": "Resubmit",
    "SELECTALL": "Select all",
    "DOWNLOADRESULT": "Download Result",
    "RESEARCHMENTRESULT": "Researchment Result",
    "IMAGEVIEWER": "Image Viewer",
    "VIEWIMAGE": "View Image",
    "FOCUSREQUIREDFIELDS": "Focus missing fields",

    "_AMcomment": "From here, there are data base values ^_~",

    "Operativo": "Operational",
    "Administrativo": "Administrative",
    "INCOMPLETE": "Incomplete",
    "READY": "Ready to send"
}